module.exports = __webpack_public_path__ + "dbe2046fe4a3cefe3c22f63249abe487.svg";